import { useEffect } from "react";

export const SITE = process.env.REACT_APP_PUBLIC_SITE_URL || "https://sisterhoodplus.com";

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const PAGE_LD_ID = "seo-page-jsonld";

/**
 * Per-route SEO for the SPA: updates <title>, description, canonical, Open Graph /
 * Twitter tags, and an optional per-page JSON-LD block on mount; restores the
 * defaults on unmount. Google renders JS, so these are indexed; the sitemap aids
 * discovery. Private routes are kept out of the sitemap and marked noindex globally.
 */
export function useSeo({ title, description, path = "", image, type = "website", jsonLd }) {
  useEffect(() => {
    const prevTitle = document.title;
    const url = `${SITE}${path}`;
    const img = image ? (/^https?:\/\//.test(image) ? image : `${SITE}${image}`) : `${SITE}/og-image.png`;

    if (title) document.title = title;
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }
    if (title) {
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:image", img);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:image", img);
    upsertCanonical(url);

    let ld = document.getElementById(PAGE_LD_ID);
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = PAGE_LD_ID;
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }

    return () => {
      document.title = prevTitle;
      const stale = document.getElementById(PAGE_LD_ID);
      if (stale) stale.remove();
    };
  }, [title, description, path, image, type, jsonLd]);
}
